import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { MouseEvent, PropsWithChildren } from "react";

import { Button } from "../Button";

type DialogProps = {
  title: string;
  isDialogVisible: boolean;
  onClose: (e: MouseEvent<HTMLElement>) => void;
};

export const Dialog = ({
  children,
  isDialogVisible,
  title,
  onClose,
}: PropsWithChildren<DialogProps>): JSX.Element => (
  <MuiDialog
    open={isDialogVisible}
    onClose={onClose}
    scroll="body"
    maxWidth="lg"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText tabIndex={-1}>{children}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" variant="contained">
        Rozumiem
      </Button>
    </DialogActions>
  </MuiDialog>
);
